<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <b-breadcrumb :items="pages" style="margin: 0px; padding: 5px 14px;"></b-breadcrumb>
        <!--<div class="col-auto align-self-end mx-xs-5">
          <b-button @click="$emit('editFtieAssignModal', null)" variant="primary">Add New</b-button>
        </div>
        <div class="col-auto align-self-end mx-xs-5">
          <b-button @click="getTestAssignResult()" variant="primary">Test Assign Result</b-button>
        </div>
        <div class="col-auto align-self-end mx-xs-5">
          <gtc-text-box v-model="test_es_id" />
        </div>-->
      </div>
    </div>
    <b-modal centered
             ref="ShowTestAssignResult" :title="`ES Info`"
             button-size="sm">
      <div class="header-col-wide mt-4 validate">
        <div>SF company<span class="text-danger pl-1">*</span></div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.SF_COMPANY">
          </gtc-text-box>
        </div>
        <div>SF Sales Territory</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.SF_SALES_TERRITORY" >
          </gtc-text-box>
        </div>
        <div>Industry</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.INDUSTRIAL">
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Vertical</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.VERTICAL" >
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>User Group</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.USER_GROUP" >
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Source</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.SF_SOURCE" >
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Request Type</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.SF_REQUEST_TYPE" >
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Issue Type</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.SF_ISSUE_TYPE" >
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Customer</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.CUSTOMER" >
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Device</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.DEVICE" >
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GRO Owner</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.GRO_SA" >
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>Contact Sales</div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="es_dict_for_assign.CONTACT_SALES">
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>SITE<span class="text-danger pl-1">*</span></div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="assign_ftie_site">
          </gtc-text-box>
        </div>
      </div>
      <div class="header-col-wide validate">
        <div>GTC Owner<span class="text-danger pl-1">*</span></div>
        <div>
          <gtc-text-box :read-only="true" size="sm" v-model="assign_gtc_owner" >
          </gtc-text-box>
        </div>
      </div>
    </b-modal>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-2">
            <div class="label mt-2">Select FTIE Site:</div>
            <div class="sub-label"></div>
            <b-form-select v-model="GRO" :options="GRO_options"
                           label="Select GRO Site:" @change="onChangeGRO"></b-form-select>
          </div>
          <div class="col-auto align-self-end">
            <b-button class="btn btn-primary min-w-4" @click="$emit('editFtieAssignModal', null, 'add')" variant="primary">Add New</b-button>
          </div>
          <div class="col-auto align-self-end">
            <b-button class="btn btn-primary min-w-4" @click="getTestAssignResult()" variant="primary">Test Assign Result</b-button>
          </div>
          <div class="col-auto align-self-end">
            <gtc-text-box class="min-w-4" v-model="test_es_id" />
          </div>
        </div>
        <!--<div class="row mt-2">

        </div>-->
      </div>
    </div>
    <div class="mt-3">

      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="filter_FtieAssignRules"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(action)="data">
            <button :id="`assign-rule-button-${data.index}`" type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-more"></button>
            <b-popover :target="`assign-rule-button-${data.index}`" custom-class="menu" triggers="focus">
              <div class="list-group list-group-flush">
                <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                        @click="$emit('editFtieAssignModal', data.item, 'Edit')"></button>
                <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-copy"
                        @click="$emit('editFtieAssignModal', data.item, 'Copy')"></button>
                <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                        @click="$emit('deleteAssignRuleModal', data.item)"></button>
              </div>
            </b-popover>
          </template>

        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'admin',
    props: ['FtieAssignRules', 'member_options', 'table_show', ],
    watch: {
      member_options: function(newVal, oldVal) { // watch it
        this.member = newVal[0].value
        console.log(newVal)
      }
    },
    data() {
      return {
        // function_name: 'Admin-Member NRE Sign Flow',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        authUrl: '',
        frontendUrl: '',
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        GRO_options_default: '',
        GRO_options: [{ value: '', text: '---Select One---' }],
        GRO: '',
        GROText: '',
        member: '',

        pages: [
          { text: 'Admin-Member Setting', href: '' },
          { text: 'FTIE Assign Rule Setting', active: true }
        ],

        fields: [
          //{ key: 'uni_id', label: '#', thClass: 'align-middle', sortable: true },
          { key: 'RULE_ID', label: 'ID', thClass: 'align-middle', sortable: true },
          { key: 'SF_COMPANY', label: 'SF Company', thClass: 'align-middle', sortable: true },
          { key: 'SF_SALES_TERRITORY', label: 'SF Sales Territory', thClass: 'align-middle', sortable: true },
          { key: 'INDUSTRIAL', label: 'Industry', thClass: 'align-middle', sortable: true },
          { key: 'VERTICAL', label: 'Vertical', thClass: 'align-middle', sortable: true },
          { key: 'USER_GROUP', label: 'User Group', thClass: 'align-middle', sortable: true },
          { key: 'SF_SOURCE', label: 'Source', thClass: 'align-middle', sortable: true },
          { key: 'SF_REQUEST_TYPE', label: 'Request Type', thClass: 'align-middle', sortable: true },
          { key: 'SF_ISSUE_TYPE', label: 'Issue Type', thClass: 'align-middle', sortable: true },
          { key: 'CUSTOMER', label: 'Customer', thClass: 'align-middle', sortable: true },
          { key: 'DEVICE', label: 'Device', thClass: 'align-middle', sortable: true },
          { key: 'GRO_SA', label: 'GRO SA', thClass: 'align-middle', sortable: true },
          { key: 'CONTACT_SALES', label: 'Contact Sales', thClass: 'align-middle', sortable: true },
          { key: 'FTIE_SITE', label: 'Site', thClass: 'align-middle', sortable: true },
          { key: 'GTC_OWNER', label: 'GTC Owner', thClass: 'align-middle', sortable: true },
          { key: 'action', label: 'Action', thClass: 'align-middle', thStyle: { 'min-width': '2.5rem !important' }, sortable: false }
        ],
        login_user_name: '',
        searching: false,
        pageDisabled: true,
        test_es_id: null,
        assign_ftie_site: null,
        assign_gtc_owner: null,
        es_dict_for_assign: {},
        test_result_show: false,
      }
    },
    created() {
      let self = this;
      self.$parent.getAssignOptions();
      self.$parent.getAssignRule();
    },
    computed: {
      filter_FtieAssignRules() {
        let self = this;
        if (self.GRO) {
          let filter_result = _.filter(self.FtieAssignRules, { 'FTIE_SITE': self.GRO });
          return filter_result;
        }
        return self.FtieAssignRules
      },
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.pages[0]['href'] = this.$root.frontEndUrl + "/admin-member/setting"
    },
    methods: {
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location.href = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var gro_option_new = new Array();
        for (i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        gro_option_new[0].text = '---Select One---'
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;

      },
      onChangeGRO(GRO) {
        let self = this;
        let groText = GRO
        self.GRO = GRO
        if('' === GRO){
          groText = '---Select One---';
        }
        else {
          let request_data = {
            action: 'load',
            GRO: self.GRO,
            member: ''
          };
          self.$parent.getNRE(request_data)
        }
      },
      getTestAssignResult() {
        let self = this;
        let url = self.$root.baseUrl + '/engineering-service/test-auto-assign/';
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        let assign_ftie_site;
        let assign_gtc_owner;
        let es_dict_for_assign;
        if (!self.test_es_id) {
          self.$message.warning('Please input engineering service id!');
        } else {
          let request_data = {
            es_ticket_id: self.test_es_id
          };
          eventHub.$emit('loading', true);
          self.$axios.post(url, request_data, { params })
            .then((response) => {
              var res = response.data;
              //console.log(res);

              if (response.status === 200) {
                self.assign_ftie_site = res['FTIE_site'];
                self.assign_gtc_owner = res['gtc_owner'];
                self.es_dict_for_assign = res['es_dict_for_assign'];
                self.test_result_show = true;
              }

              else if (response.status === 204) {
                self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
                console.log(res.description);
              }

              else if (res.description == "login") {
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                self.$axios.get(url)
                  .then((res) => {
                    console.log('logout');
                    self.$router.push("/");
                  })
                window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
              } else {
                self.$message.exception('Internal Server Error!');
                console.log(res.description);
              }
            }, (error) => {
              console.log(error);
              self.$message.exception('Internal Server Error!');
            })
            .finally(() => {
              eventHub.$emit('loading', false);
              self.$refs['ShowTestAssignResult'].show();
            })
        }
      },
      //ShowTestAssignResult() {
      //  let self = this;
      //  self.$refs['ShowTestAssignResult'].show();
      //}
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FtieAssignSetting.vue